import { render, staticRenderFns } from "./newOnboarding.vue?vue&type=template&id=61e52460&scoped=true"
import script from "./newOnboarding.vue?vue&type=script&lang=js"
export * from "./newOnboarding.vue?vue&type=script&lang=js"
import style0 from "./newOnboarding.vue?vue&type=style&index=0&id=61e52460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e52460",
  null
  
)

export default component.exports